import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledPriceGroupBadge = styled(Typography)(({ theme }) => ({
	alignSelf: 'flex-start',
	padding: theme.spacing(0.5, 0.75),
	borderRadius: 2,
	backgroundColor: theme.palette.ticketing?.main,
	color: theme.palette.ticketing?.contrastText,
}));
